<template>
  <button class="burger" data-voicetext="открыть боковое меню" @click="$emit('click', $event)">
      <BurgerIcon class="burger__icon"/>
  </button>
</template>

<script>
import BurgerIcon from '@/assets/images/icons/burger.svg?inline';
export default {
    components: {
        BurgerIcon,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.burger {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    flex: 0 0 auto;
    cursor: pointer;
    transform: scale(.925);
    transition: transform .02s ease-in;
    width: mrem(40);
    height: mrem(40);
    color: var(--color-primary);
    background-color: white;

    @include on-desktop {
        width: rem(62);
        height: rem(52);
        background-color: var(--color-primary);
        color: white;
        border-radius: rem($border-radius-value);
    }

    &__icon {
        width: mrem(28);
        height: mrem(20);

        @include on-desktop {
            width: rem(36);
            height: rem(26);
        }
    }

    &:hover {
        transform: scale(1);
    }
}
</style>
